import { Link } from 'react-router-dom';
import LegalLayout from '@/components/LegalLayout';
import { BUSINESS, ALLERGY_NOTE } from '@/lib/legal';

export default function Allergy() {
  return (
    <LegalLayout
      title="Allergy Policy"
      intro="Please read this carefully before ordering or eating our food."
    >
      <h2>Shared kitchen &amp; cross-contamination</h2>
      {ALLERGY_NOTE.map((p, i) => (
        <p key={i}>{p}</p>
      ))}

      <h2>What this means for you</h2>
      <ul>
        <li>We cannot prepare guaranteed allergen-free meals or dedicated allergen-free batches.</li>
        <li>Ingredients and recipes may change day to day as our menu rotates.</li>
        <li>If you have a severe allergy, we strongly advise against eating our food.</li>
      </ul>

      <h2>Your acknowledgment</h2>
      <p>
        When you subscribe or renew, you are asked to confirm that you have read and understood this notice and
        that you accept the risk of cross-contamination. If you are unsure, please{' '}
        <Link to="/support">contact us</Link> before ordering.
      </p>

      <h2>Questions</h2>
      <p>
        Email <a href={`mailto:${BUSINESS.supportEmail}`}>{BUSINESS.supportEmail}</a> or call {BUSINESS.phone} and
        we'll be glad to talk through ingredients with you.
      </p>
    </LegalLayout>
  );
}
